import { render } from "./notifications.vue?vue&type=template&id=f4762d62&ts=true"
import script from "./notifications.vue?vue&type=script&lang=ts"
export * from "./notifications.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__